import { AudioService } from '../../services/audio.service';

export interface TwilioVoiceParameterModel {
    name: string;
    type: string;
    model: string;
    audioService: AudioService;
    src: string;
    isAppointment: boolean;
    containsAppointment: string;
    canPreview: boolean;
    ttsMessage: string;
}

export const soundSoundIdURL = '/servlets/audio/sound/play/';
export const soundTTSUrl = '/servlets/audio/tts/play/?tts=';

export const callScripts = {
    handleScriptReminder: {
        companyIntroTTS: {
            type: 'tts',
            model: 'template.voiceCompanyIntroTTS',
            isForNormal: true,
            isForVoicemail: true
        },
        companyIntro2TTS: {
            type: 'tts',
            model: 'template.voiceCompanyIntro2TTS',
            isForNormal: true,
            isForVoicemail: true
        },
        toTTS: {
            type: 'tts',
            model: 'template.voiceToTTS',
            isForNormal: true,
            isForVoicemail: true
        },
        firstNameTTS: {
            type: 'tts',
            model: 'template.voiceFirstNameTTS',
            isForNormal: true,
            isForVoicemail: true
        },
        regardingTTS: {
            type: 'tts',
            model: 'template.voiceRegardingTTS',
            isForNormal: true,
            isForVoicemail: false
        },
        regarding2TTS: {
            type: 'tts',
            model: 'template.voiceRegarding2TTS',
            isForNormal: true,
            isForVoicemail: false
        },
        regardingVoicemailTTS: {
            type: 'tts',
            model: 'template.voiceRegardingVoicemailTTS',
            isForNormal: false,
            isForVoicemail: true
        },
        regardingVoicemail2TTS: {
            type: 'tts',
            model: 'template.voiceRegardingVoicemail2TTS',
            isForNormal: false,
            isForVoicemail: true
        },
        appointmentTimeTTS: {
            type: 'tts',
            model: 'template.voiceAppointmentTimeTTS',
            isForNormal: true,
            isForVoicemail: true
        },
        locationTTS: {
            type: 'tts',
            model: 'template.voiceLocationTTS',
            isForNormal: true,
            isForVoicemail: true
        },
        location2TTS: {
            type: 'tts',
            model: 'template.voiceLocation2TTS',
            isForNormal: true,
            isForVoicemail: true
        },
        press5ToConfirmTTS: {
            type: 'tts',
            model: 'template.voicePress5ToConfirmTTS',
            isForNormal: true,
            isForVoicemail: false
        },
        instructionTTS: {
            type: 'tts',
            model: 'template.voiceInstructionTTS',
            isForNormal: true,
            isForVoicemail: true
        },
        instruction2TTS: {
            type: 'tts',
            model: 'template.voiceInstruction2TTS',
            isForNormal: true,
            isForVoicemail: true
        },
        instructionVoicemailTTS: {
            type: 'tts',
            model: 'template.voiceInstructionVoicemailTTS',
            isForNormal: false,
            isForVoicemail: true
        },
        instructionVoicemail2TTS: {
            type: 'tts',
            model: 'template.voiceInstructionVoicemail2TTS',
            isForNormal: false,
            isForVoicemail: true
        },
        press1ToRepeatTTS: {
            type: 'tts',
            model: 'template.voicePress1ToRepeatTTS',
            isForNormal: true,
            isForVoicemail: false
        },
        goodbyeTTS: {
            type: 'tts',
            model: 'template.voiceGoodbyeTTS',
            isForNormal: true,
            isForVoicemail: true
        }
    },
    handleScriptCommunication: {
        companyIntroTTS: {
            type: 'tts',
            model: 'template.voiceCompanyIntroTTS',
            isForNormal: true,
            isForVoicemail: true
        },
        companyIntro2TTS: {
            type: 'tts',
            model: 'template.voiceCompanyIntro2TTS',
            isForNormal: true,
            isForVoicemail: true
        },
        toTTS: {
            type: 'tts',
            model: 'template.voiceToTTS',
            isForNormal: true,
            isForVoicemail: true
        },
        firstNameTTS: {
            type: 'tts',
            model: 'template.voiceFirstNameTTS',
            isForNormal: true,
            isForVoicemail: true
        },
        regardingTTS: {
            type: 'tts',
            model: 'template.voiceRegardingTTS',
            isForNormal: true,
            isForVoicemail: false
        },
        regarding2TTS: {
            type: 'tts',
            model: 'template.voiceRegarding2TTS',
            isForNormal: true,
            isForVoicemail: false
        },
        regarding3TTS: {
            type: 'tts',
            model: 'template.voiceRegarding3TTS',
            isForNormal: true,
            isForVoicemail: false
        },
        regardingVoicemailTTS: {
            type: 'tts',
            model: 'template.voiceRegardingVoicemailTTS',
            isForNormal: false,
            isForVoicemail: true
        },
        regardingVoicemail2TTS: {
            type: 'tts',
            model: 'template.voiceRegardingVoicemail2TTS',
            isForNormal: false,
            isForVoicemail: true
        },
        regardingVoicemail3TTS: {
            type: 'tts',
            model: 'template.voiceRegardingVoicemail3TTS',
            isForNormal: false,
            isForVoicemail: true
        },
        press1ToRepeatTTS: {
            type: 'tts',
            model: 'template.voicePress1ToRepeatTTS',
            isForNormal: true,
            isForVoicemail: false
        },
        companyOutroTTS: {
            type: 'tts',
            model: 'template.companyOutroTTS',
            isForNormal: true,
            isForVoicemail: true
        },
        companyOutro2TTS: {
            type: 'tts',
            model: 'template.companyOutro2TTS',
            isForNormal: true,
            isForVoicemail: true
        },
        goodbyeTTS: {
            type: 'tts',
            model: 'template.voiceGoodbyeTTS',
            isForNormal: true,
            isForVoicemail: true
        }
    }
};
